import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

import { ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
import { Acesso } from 'src/app/core/acesso';
import { CarregarPerfil } from 'src/app/core/carregar-perfil';
import { PublicoAlvoAtividade } from '../../../../../core/publico-alvo-atividade';

@Component({
    selector: 'listar-publico-alvo-atividade',
    templateUrl: './listar-publico-alvo-atividade.component.html',
    styleUrls: ['./listar-publico-alvo-atividade.component.css']
})
export class ListarPublicosAlvoAtividadeComponent implements OnInit {

    @Output() onAtualizarPublicoAlvoAtividade = new EventEmitter();
    @Output() onAdicionarPublicoAlvoAtividade = new EventEmitter();

    @Input() publicosAlvosAtividade: PublicoAlvoAtividade[];

    @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

    mostrarTabela = false;
    msg: string;

    displayedColumns: string[] = ['descricao', 'acoes'];
    dataSource: MatTableDataSource<PublicoAlvoAtividade> = new MatTableDataSource();

    perfilAcesso: Acesso = new Acesso();
    carregarPerfil: CarregarPerfil = new CarregarPerfil();

    filteredRequests: MatTableDataSource<PublicoAlvoAtividade> = new MatTableDataSource();
    descricaoFiltered: string;
    dataFiltered: string;

    constructor(private activatedRoute: ActivatedRoute) {
    }

    ngOnInit() {
        this.carregarPerfil.carregar(this.activatedRoute.snapshot.data.perfilAcesso, this.perfilAcesso);

        this.dataSource.paginator = this.paginator;
        this.carregarLista();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["publicosAlvosAtividade"] && !_.isEmpty(changes["publicosAlvosAtividade"].currentValue)) {
            this.carregarLista();
        }
    }

    carregarLista() {
        if (_.isEmpty(this.publicosAlvosAtividade)) {
            this.mostrarTabela = false;
            this.msg = 'Nenhum público alvo cadastrado.';
        } else {
            this.dataSource.data = this.publicosAlvosAtividade;
            this.mostrarTabela = true;
        }

        this.filteredRequests = this.dataSource;
    }

    deletar(publicoAlvoAtividade: any): void {
        const index = this.publicosAlvosAtividade.indexOf(this.publicosAlvosAtividade.find(col => col === publicoAlvoAtividade));
        if (index >= 0) {
            this.publicosAlvosAtividade.splice(index, 1);
            this.carregarLista();
        }
    }

    atualizar(publicoAlvoAtividade: PublicoAlvoAtividade) {
        this.onAtualizarPublicoAlvoAtividade.emit(publicoAlvoAtividade);
    }

    novo() {
        this.onAdicionarPublicoAlvoAtividade.emit(true);
    }

    get descricaoFilter(): string {
        return this.descricaoFiltered;
    }

    set descricaoFilter(value: string) {
        this.descricaoFiltered = value;
        this.filteredRequests = this.performFilter();
    }

    get dataFilter(): string {
        return this.dataFiltered;
    }

    set dataFilter(value: string) {
        this.dataFiltered = value;
        this.filteredRequests = this.performFilter();
    }

    performFilter(): MatTableDataSource<PublicoAlvoAtividade> {
        let filteredRequestsX = this.dataSource.data.filter(
            (request: PublicoAlvoAtividade) => (!this.descricaoFiltered || request.descricao.includes(this.descricaoFiltered)) &&
                (!this.dataFiltered)
        );
        return !!this.descricaoFiltered || !!this.dataFiltered
            ? new MatTableDataSource(filteredRequestsX)
            : this.dataSource;
    }

}
